import { observer } from "mobx-react";
import React from "react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import { ProductConfigurationStore } from "../Stores/ProductConfigurationStore";
import { Link } from "react-router-dom";
import utilsFunctions from "../Utils/ModuleHelpers";
import "./SummaryDetails.css";
import { Options } from "../config";
import { compact } from "lodash";

type Props = {
	productConfigurationStore: ProductConfigurationStore;
};

@observer
class SummaryDetails extends React.Component {


	render() {

		const getAnchor = utilsFunctions.getAnchor(store.configs?.detailsStepHeadline);
		let plannedPlantations = compact(store.productConfigurationStore?.getSelectedOptionsForKey(Options.plannedPlantations).map(option => option.name) || [])
		let rowWidths = compact(store.productConfigurationStore?.getSelectedOptionsForKey(Options.rowWidths).map(option => option.name) || [])
		let coulterWidths = compact(store.productConfigurationStore?.getSelectedOptionsForKey(Options.coulterWidths).map(option => option.name) || [])

		plannedPlantations = plannedPlantations.length === 0 ? [" - "] : plannedPlantations
		rowWidths = rowWidths.length === 0 ? [" - "] : rowWidths
		coulterWidths = coulterWidths.length === 0 ? [" - "] : coulterWidths


		return (
			<div className="col-12 col-lg-11 summary-details">
				<div className="summary-entity-header">
					<h3 className="summary-entity-headline">{store.configs?.detailsStepHeadline}</h3>
					<Link className="btn btn-simple" to={"/#" + getAnchor}>
						{store.configs?.generalChangeText}
					</Link>
				</div>
				<div className="summary-tile-wrapper">
					{store.productConfigurationStore?.modules?.globalModuleOptions?.coulterWidths &&
						<div className="summary-detail-tile">
							<h4 className="module-title">{store.configs?.detailsStepSubheadlineCoulterWidths}</h4>
							<span>{coulterWidths.join(", ")}</span>
						</div>
					}
					<div className="summary-detail-tile">
						<h4 className="module-title">{store.configs?.detailsStepSubheadlineRowWidths}</h4>
						<span>{rowWidths.join(", ")}</span>
					</div>
					<div className="summary-detail-tile">
						<h4 className="module-title">{store.configs?.detailsStepSubheadlinePlantation}</h4>
						<span>{plannedPlantations.join(", ")}</span>
					</div>
					<div className="summary-detail-tile">
						<h4 className="module-title">{store.configs?.detailsStepSubheadlineTrackWidth}</h4>
						<span>{store.productConfigurationStore?.selection.textNotes[Options.trackWidth]}</span>
					</div>
				</div>
			</div>
		);
	}
}

export default SummaryDetails;
